import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const EditAccess = ({ children }) => {
  const user = useSelector((/** @type {Object} */ state) => state.user);

  return <>{user.canWrite && children}</>;
};

EditAccess.defaultProps = {
  children: null,
};

EditAccess.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.func]),
};

export default EditAccess;
